(() => {
  window.swinger.observer.initialize('.swinger-select__select[name="country"]', (elem) => {
    if (elem.value) {
      return;
    }

    const geo = window.swinger.user.getGeo();
    const option = elem.querySelector(`option[value="${geo}"]`);

    if (!option) {
      return;
    }

    option.selected = true;
  });
})();
